"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxIdType = void 0;
var TaxIdType;
(function (TaxIdType) {
    TaxIdType["CPF"] = "CPF";
    TaxIdType["CNPJ"] = "CNPJ";
})(TaxIdType || (exports.TaxIdType = TaxIdType = {}));
//# sourceMappingURL=buyer.js.map